module.exports = __webpack_public_path__ + "static/img/no-cerfity-img.24115d08.png";